export default __webpack_public_path__ + "static/holding-car-home-screen-1-f952ed15c6fb83bd969a4f91ac552eee.png";